<template>
    <div class="footerBigBox"></div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.footerBigBox {
}
</style>
